import useAxiosService from './useAxiosService'
import axios from 'axios'
import { IResponse } from 'interfaces/services'
import {
  IAccountBank,
  IBank,
  ICreateUpdateBankQuery
} from 'pages/accountClinicInfo/interfaces'

export const useBankService = () => {
  const { post, patch, get, dele } = useAxiosService()

  const getAllBankVn = async () => {
    const response: any = await axios.get(`/assets/banks.json`)
    return response?.data?.banks_list as Array<IBank>
  }

  const getAllAccountBanks = async () => {
    const response: any = await get(`/wallet/partner?all=true`)
    return response as IResponse<{ wallet_partners: Array<IAccountBank> }>
  }

  const saveBankAccount = async (query: ICreateUpdateBankQuery) => {
    const response: any = await post(`/wallet/partner`, query)
    return response as IResponse<any>
  }

  const updateBankAccount = async (query: ICreateUpdateBankQuery) => {
    const response: any = await patch(`/wallet/partner`, query)
    return response as IResponse<any>
  }

  const deleteAccountBank = async (query: any) => {
    const res = await dele(`wallet/partner`, { wallet_partner_id: query })
    return res as IResponse<any>
  }

  return {
    getAllAccountBanks,
    saveBankAccount,
    updateBankAccount,
    getAllBankVn,
    deleteAccountBank
  }
}
